<div class="spinner-wrapper">
  <img class="logo" src="assets/img/loader-ai.gif" />
</div>
